export default __webpack_public_path__ + "static/media/mastercard.fdd172ae.png";